//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <ResultPage :imgSrc="startShoppingSrc" />
</template>

<script setup>
import ResultPage from "./ResultPage";
import { ref } from "vue";

const startShoppingSrc = ref(
  "https://assets.glasseson.com/web/images/goeyes_start_shopping.png"
);
</script>
